import { useMemo } from 'react'
import { SearchList01Icon } from '@hugeicons/core-solid-rounded'
import { useLingui } from '@lingui/react/macro'

import FilterSelect from '@/components/ui/FilterSelect'
import Input from '@/components/ui/Input'
import { helpers } from '@/features/goodies'

import {
  AddPromotionButton,
  PromotionTable,
  usePromotionTable
} from '@/features/promotion'

function Feed() {
  const { t } = useLingui()
  const typeOptions = helpers.useGoodieTypeOptions()

  const possibleTypes = useMemo(
    () => typeOptions.map(({ value }) => value),
    [typeOptions]
  )

  const {
    queryVariables,
    selectedPromotions,
    types,
    search,
    setSearch,
    setTypes,
    onSelectPromotion,
    updateSort
  } = usePromotionTable(possibleTypes)

  return (
    <main className="flex flex-col pr-5 pb-6 max-h-full">
      <div className="flex w-full flex-col md:flex-row gap-2.5 pt-1 pb-6 items-start md:items-center">
        <div className="flex flex-row gap-2.5 items-center">
          <AddPromotionButton />
          <FilterSelect
            options={typeOptions}
            selectedValues={types}
            onChange={setTypes}
            placeholder={t`All types`}
          />
        </div>
        <Input
          Icon={SearchList01Icon}
          placeholder={t`Search…`}
          value={search}
          onChange={event => setSearch(event.target.value)}
        />
      </div>
      <div className="relative w-full rounded bg-white p-5 flex-1 overflow-hidden flex flex-col">
        <div className="size-full overflow-y-auto inset-0">
          <PromotionTable
            variables={queryVariables}
            selectedIds={selectedPromotions}
            onSelect={onSelectPromotion}
            onChangeSort={updateSort}
            hideCheckbox
          />
        </div>
      </div>
    </main>
  )
}

export default Feed
